import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from '@haldor/ui';
import * as microsoftTeams from "@microsoft/teams-js";
import api from 'lib/api';
import { informAboutTabData } from 'actions/sections';
import Input from 'components/Inputs/input';

var TabConfigure = /*#__PURE__*/function (_Component) {
  _inherits(TabConfigure, _Component);

  var _super = _createSuper(TabConfigure);

  function TabConfigure(props) {
    var _this;

    _classCallCheck(this, TabConfigure);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getContext", function () {
      return new Promise(function (resolve, reject) {
        microsoftTeams.app.getContext().then(function (context) {
          if (context) {
            resolve(context);
          } else {
            reject(new Error("Context was not found"));
          }
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setFieldValidation", function (message) {
      var hideForms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      _this.state.fieldValidation.valid = false;
      _this.state.fieldValidation.text = message;
      _this.state.fieldValidation.hideForms = hideForms;

      _this.setState({
        fieldValidation: _this.state.fieldValidation,
        loadingGroupData: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "removeFieldValidation", function () {
      _this.state.fieldValidation.valid = true;
      _this.state.fieldValidation.hideForms = false;
      _this.state.fieldValidation.text = '';

      _this.setState({
        fieldValidation: _this.state.fieldValidation
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onValidate", function () {
      var name = _this.state.title;
      var tab = window.location.origin + "/haldor-tab";

      if (name != '' && name != null && tab != '') {
        microsoftTeams.pages.config.setConfig({
          contentUrl: tab,
          suggestedDisplayName: name
        });
        microsoftTeams.pages.config.setValidityState(true);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      if (_this.state.invalidMessage) {
        return /*#__PURE__*/React.createElement("div", {
          className: "form-container form-create_task"
        }, /*#__PURE__*/React.createElement("h1", null, _this.props.translate('planning')), /*#__PURE__*/React.createElement("p", null, _this.props.translate(_this.state.invalidMessage)));
      }

      return /*#__PURE__*/React.createElement("div", null, _this.state.isLoading || _this.state.loadingGroupData ? _this.renderForm() : null);
    });

    _this.state = {
      tab: 'HALDOR_PLAN_COMBO',
      title: 'Plans',
      isLoading: true,
      loadingGroupData: true,
      showErrorLogin: false,
      hideSchoolInput: true,
      groupId: null,
      showConsentRequest: false,
      schoolId: 0,
      groupType: 'EDUCATION_GROUP',
      invalidMessage: null,
      user: {
        email: null,
        firstName: null,
        lastName: null,
        userRoles: []
      },
      fieldValidation: {
        valid: null,
        text: '',
        hideForms: false
      }
    };

    _this.onTitleChange.bind(_assertThisInitialized(_this));

    return _this;
  }

  _createClass(TabConfigure, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var context;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                document.body.style.overflow = 'hidden';
                document.body.style.backgroundColor = 'white';
                _context.next = 4;
                return this.getContext();

              case 4:
                context = _context.sent;
                console.log(context);

                if (context != null && context.team.userRole === 0) {
                  this.initTabConfigure();
                } else {
                  this.setState({
                    invalidMessage: 'Only owners can add this app to the team'
                  });
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "initTabConfigure",
    value: function initTabConfigure() {
      var _this2 = this;

      this.setState({
        showErrorLogin: false
      });
      microsoftTeams.app.getContext().then(function (context) {
        if (context != null) {
          console.log(context);
          api.post('log/Apps/CoursePlan/Context/Configure', context);

          _this2.setState({
            groupId: context.team.groupId
          });

          microsoftTeams.pages.config.registerOnSaveHandler(function (saveEvent) {
            microsoftTeams.app.getContext().then( /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context) {
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        saveEvent.notifySuccess();

                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x) {
                return _ref.apply(this, arguments);
              };
            }());
          });
          microsoftTeams.pages.getConfig().then(function (settings) {
            if (settings != null && settings.suggestedDisplayName != null) {
              _this2.setState({
                title: settings.suggestedDisplayName
              });
            }
          });

          _this2.onValidate();
        }
      });
      this.setState({
        isLoading: false
      });
    }
  }, {
    key: "onTitleChange",
    value: function onTitleChange(event) {
      var _this3 = this;

      this.setState({
        title: event.target.value
      }, function () {
        _this3.onValidate();
      });
    }
  }, {
    key: "renderForm",
    value: function renderForm() {
      return /*#__PURE__*/React.createElement("div", {
        className: "form-container form-create_task"
      }, /*#__PURE__*/React.createElement("form", {
        className: "form form-component",
        onKeyDown: this.handleKeyDown
      }, /*#__PURE__*/React.createElement("h1", null, this.props.translate('planning')), /*#__PURE__*/React.createElement("div", null, this.props.translate('configure-welcome-to-planning')), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      }), /*#__PURE__*/React.createElement(Input, {
        name: "title",
        type: "text" //placeholder={}
        ,
        maxLength: "199",
        label: this.props.translate('title') + '*',
        value: this.state.title,
        onChange: this.onTitleChange.bind(this)
      })));
    }
  }]);

  return TabConfigure;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps, {
  informAboutTabData: informAboutTabData
})(TabConfigure);